var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6000 4000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#060b9a;}.tim-nhat-bang{fill:#a5a7ff;}.cls-2{fill:#ff8327;}.cls-12,.cls-3{fill:#fff;}.vang-decor{fill:#ffe046;}.cls-4{fill:#7877ff;}.cls-5{fill:#ffba9f;}.tim-bang{fill:#4f50ff;}.cls-6{fill:#8e97ef;}.nen-xanh{fill:#3537ec;}.vang-bieu-do{fill:#ff0;}.da-dam{fill:#e07e5f;}.cls-7{fill:#e03875;}.vang-dam{fill:#fb3;}.cls-8{fill:#840d43;}.cls-9{fill:#00c49c;}.cls-10{fill:#222abc;}.cls-11{fill:#080999;}.do-dam-ao{fill:#aa1d57;}.cls-12{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3935.69,1913.27H3720.48a104.74,104.74,0,0,1-104.62-104.63V1420.08a104.74,104.74,0,0,1,104.62-104.63h215.21a104.74,104.74,0,0,1,104.62,104.63v388.56A104.74,104.74,0,0,1,3935.69,1913.27Zm-215.21-591.82a98.74,98.74,0,0,0-98.62,98.63v388.56a98.74,98.74,0,0,0,98.62,98.63h215.21a98.74,98.74,0,0,0,98.62-98.63V1420.08a98.74,98.74,0,0,0-98.62-98.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "tim-nhat-bang",
    x: 3519.82,
    y: 1522.42,
    width: 476.35,
    height: 202.28,
    rx: 25.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3563.01,
    y: 1546.75,
    width: 55.89,
    height: 14.6,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3636.7,
    y: 1546.75,
    width: 55.89,
    height: 14.6,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "vang-decor",
    d: "M3557,1660.54s56-64.55,129.58-35.6,114.92,18.14,159.48-7.59c0,0,77.89-47.34,112.14-43.54V1688H3557Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 3594.94,
    cy: 1043.47,
    r: 36.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 4270.45,
    cy: 2969.02,
    r: 32.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 1621.81,
    cy: 2320.27,
    r: 36.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 2524.97,
    cy: 778.18,
    rx: 8.56,
    ry: 41.93,
    transform: "translate(189.29 2013.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 2524.97,
    cy: 778.18,
    rx: 41.93,
    ry: 8.56,
    transform: "translate(189.29 2013.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1472.7,
    cy: 2283.81,
    rx: 8.56,
    ry: 41.93,
    transform: "translate(-1183.56 1710.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1472.7,
    cy: 2283.81,
    rx: 41.93,
    ry: 8.56,
    transform: "translate(-1183.56 1710.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3806.68,
    cy: 1589.84,
    r: 73.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3797.78,1609.1c1.62,4.21,5.53,4.21,7.68,4.21,5,0,7.82-2.85,7.82-5.92,0-5.36-5-7.41-11.19-9.23-14.15-4.11-24.39-12.54-24.39-24.85,0-13.22,7-22,20.62-24.62v-10.37h19.28v10.94c7.68,2.51,13.34,7.07,16.17,14.7l-20.22,8.21c-1.88-4.1-4.45-5.13-7.14-5.13a5.83,5.83,0,0,0-5.8,5.59c0,4.21,6.2,6,10.52,7.63,3.5,1.26,6.06,2.28,8.22,3.31,11.73,5.35,16.85,11.85,16.85,23.82,0,10.71-8.09,19.94-18.6,23.59v10.37h-19.28v-9.57c-11.86-1.26-19.41-7.64-21.16-19.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 4027.14,
    cy: 1880.21,
    r: 108.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4045.76,1871a125.53,125.53,0,0,0-12.08-4.85c-6.34-2.35-15.45-5-15.45-11.23a8.56,8.56,0,0,1,8.51-8.21c4,0,7.74,1.51,10.5,7.54l29.73-12.07c-4.16-11.22-12.48-17.92-23.78-21.6v-16.09h-28.34v15.25c-20,3.85-30.31,16.75-30.31,36.19,0,18.09,15.06,30.48,35.87,36.52,9.11,2.67,16.43,5.69,16.43,13.56,0,4.52-4.16,8.71-11.48,8.71-3.17,0-8.91,0-11.29-6.19l-30.32,4.18c2.57,17.92,13.67,27.3,31.1,29.15v14.07h28.34v-15.24c15.46-5.36,27.34-18.94,27.34-34.68C4070.53,1888.42,4063,1878.87,4045.76,1871Zm-6.34,67.51v14.41h-20.8V1939c-16.84-.84-28.34-9.38-30.51-23.62l24.17-3.52c4,5.53,9.51,5.87,13.08,5.87,9.5,0,15.26-5.53,15.26-11.73,0-9.88-7.74-13.4-19.23-16.58-18.82-5.37-33.09-16.58-33.09-33.5,0-18.1,11.1-30.5,30.32-33.68v-14.57h20.8v15.07c10.31,2.68,19.62,8.54,23.19,17.76l-23.78,9.71c-3-5.35-8.32-6.53-12.09-6.53-7.92,0-12.28,5.53-12.28,11.23,0,8.88,12.28,12.39,19.42,14.74a71.65,71.65,0,0,1,9.9,4c16.25,7.2,23,16.25,23,32.33C4066.77,1921.42,4055.27,1934.32,4039.42,1938.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4066.77,1906c0,15.41-11.5,28.31-27.35,32.5v14.41h-20.8V1939c-16.84-.84-28.34-9.38-30.51-23.62l24.17-3.52c4,5.53,9.51,5.87,13.08,5.87,9.5,0,15.26-5.53,15.26-11.73,0-9.88-7.74-13.4-19.23-16.58-18.82-5.37-33.09-16.58-33.09-33.5,0-18.1,11.1-30.5,30.32-33.68v-14.57h20.8v15.07c10.31,2.68,19.62,8.54,23.19,17.76l-23.78,9.71c-3-5.35-8.32-6.53-12.09-6.53-7.92,0-12.28,5.53-12.28,11.23,0,8.88,12.28,12.39,19.42,14.74a71.65,71.65,0,0,1,9.9,4C4060,1880.88,4066.77,1889.93,4066.77,1906Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2908,895s-26.12,87.74,2.09,91.92,46-30.29,46-30.29l1-56.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 2497.56,
    cy: 1983.94,
    r: 153.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 2382.13,
    cy: 2320.27,
    r: 85.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2446.4,1465.82l-16.6-40.9S2372,1342.76,2361,1334s-40.17-22.55-40.17-22.55l-64,95.18s61.11,48.27,89.81,57.32,41.8,23.27,41.8,23.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2933.59,1637.34s-39.18,30.57-95.24,62.51c-20.51,11.69-43.27,23.55-67.19,34.18-12.94,5.76-26.22,11.13-39.69,15.93C2625.12,1787.89,2335,1499.52,2335,1499.52l44.35-66.8,286.39,148.62,15.78-10.75,25.15-17.14,74.21-50.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2380.56,1308.78l-2.8,54.92s-6.85,18.87-3.7,36,41.9,5.41,41.9,5.41-14.68-48.26-13.38-64.72S2391,1291.37,2380.56,1308.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2318.38,1318.59s10.47,26,8.88,42.54-1.73,38.52-20,55.79-38.9,9.74-39.93,7.58-10.17-43.63-10.17-43.63-2.31-21.35,5.23-28.82,12.37-6.73,12.37-6.73-2.82-12.61,5.58-17.19,15.16-2.21,15.16-2.21-7.28-6.72,4.9-14.27S2318.38,1318.59,2318.38,1318.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340,2283H1744.09c-58.25,0-110.44-47.09-116.56-105.17L1484.25,818.86c-3.69-35.06,10.24-66.12,34.68-85.23,6.4-5,43.41-32.44,51.13-35.66,11.62-4.86-5.3,15.72,8.58,15.72h595.92c58.25,0,110.44,47.09,116.56,105.17L2434.4,2177.78c3.11,29.57,34.9,30.11,17.21,49.22-2.52,2.73-46.43,31.49-49.28,33.89C2385.93,2274.72,2364.37,2283,2340,2283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2385.39,2249.69H1789.47c-58.25,0-110.44-47.09-116.56-105.17L1529.63,785.6c-6.12-58.08,36.13-105.17,94.38-105.17h595.93c58.25,0,110.43,47.09,116.56,105.17l143.27,1358.92C2485.9,2202.6,2443.64,2249.69,2385.39,2249.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-nhat-bang",
    d: "M2432.38,2197.16c-11.55,12.83-28.24,19.9-47,19.9H1789.47c-20.09,0-40-7.95-56-22.4s-26-33.49-28.13-53.56l-43.8-415.38-54.37-515.65-21.42-203.13L1569.12,849h741.26l85,806.54,21.31,202.11,21.42,203.15,9.18,87.1C2449.31,2166.77,2444,2184.24,2432.38,2197.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-bang",
    d: "M2274.59,1165.54H1761.51c-28.58,0-54.22-22.92-57.28-51.2L1691.55,997c-3.06-28.28,17.63-51.2,46.2-51.2h513.09c28.57,0,54.22,22.92,57.27,51.2l12.69,117.33C2323.86,1142.62,2303.17,1165.54,2274.59,1165.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2432.38,2197.16c-11.55,12.83-28.24,19.9-47,19.9H1789.47c-20.09,0-40-7.95-56-22.4s-26-33.49-28.13-53.56l-43.8-415.38c62.9,21.8,166.76,60.38,234.27,99,102.36,58.49,56.4,56.4,127.43,114.91s140,48,227.72,60.58,173.4,12.54,185.94,56.41q.6,2.11,1.23,4.26l9.18,87.1C2449.31,2166.77,2444,2184.24,2432.38,2197.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nen-xanh",
    d: "M2310.38,849H1569.12l-7-66.86c-2-18.83,3.32-36.3,14.93-49.22s28.26-19.91,47-19.91h595.92c20.09,0,40,8,56,22.4s26,33.49,28.14,53.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2258.42,1226.52,2168,1197.64s-84.77-38.26-89.28-48,6-34.51,6-34.51l95.28-46.52,65.27,33.77,63.77,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vang-bieu-do",
    d: "M2291,1141.63H1777.94c-28.57,0-54.22-22.93-57.27-51.2L1708,973.09c-3-28.27,17.63-51.2,46.21-51.2h513.08c28.58,0,54.22,22.93,57.28,51.2l12.68,117.34C2340.29,1118.7,2319.6,1141.63,2291,1141.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2259.37,1463.27H1746.29c-28.58,0-54.22-22.92-57.28-51.2l-12.68-117.33c-3.06-28.28,17.63-51.2,46.2-51.2h513.09c28.57,0,54.22,22.92,57.27,51.2l12.69,117.33C2308.63,1440.35,2288,1463.27,2259.37,1463.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-bang",
    d: "M2290.74,1753.4H1777.65c-28.57,0-54.22-22.92-57.27-51.2l-12.69-117.33c-3-28.28,17.63-51.2,46.21-51.2H2267c28.58,0,54.22,22.92,57.28,51.2l12.68,117.33C2340,1730.48,2319.31,1753.4,2290.74,1753.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2322.1,2043.53H1809c-28.58,0-54.22-22.92-57.28-51.2L1739.06,1875c-3.06-28.28,17.63-51.2,46.2-51.2h513.09c28.57,0,54.22,22.92,57.27,51.2l12.69,117.33C2371.36,2020.61,2350.68,2043.53,2322.1,2043.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1878.79,1082.85h-64.15c-11.19,0-21.36-8.95-22.71-20l-9-72.93c-1.35-11,6.61-20,17.8-20h64.15c11.19,0,21.36,8.95,22.71,20l9,72.93C1898,1073.9,1890,1082.85,1878.79,1082.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1878.79,1085.85h-64.15c-12.63,0-24.16-10.15-25.69-22.63l-9-72.93a20.62,20.62,0,0,1,4.88-16.45,20.87,20.87,0,0,1,15.89-6.9h64.15c12.63,0,24.16,10.15,25.69,22.62l9,72.93a20.42,20.42,0,0,1-20.78,23.36Zm-78-112.91a14.91,14.91,0,0,0-11.39,4.88,14.71,14.71,0,0,0-3.43,11.74l9,72.93c1.17,9.57,10,17.36,19.73,17.36h64.15a14.93,14.93,0,0,0,11.39-4.88,14.72,14.72,0,0,0,3.43-11.75l-9-72.93c-1.18-9.57-10-17.35-19.74-17.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1838.28,1402.46h-64.15c-11.19,0-21.36-9-22.72-20l-9-72.93c-1.36-11,6.61-20,17.8-20h64.15c11.18,0,21.35,9,22.71,20l9,72.93C1857.43,1393.51,1849.46,1402.46,1838.28,1402.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1838.28,1405.46h-64.15c-12.64,0-24.16-10.15-25.69-22.62l-9-72.94a20.41,20.41,0,0,1,20.78-23.35h64.15c12.63,0,24.15,10.15,25.69,22.62l9,72.93a20.42,20.42,0,0,1-20.77,23.36Zm-78-112.91a14.9,14.9,0,0,0-11.39,4.88,14.71,14.71,0,0,0-3.43,11.74l9,72.93c1.18,9.57,10,17.36,19.74,17.36h64.15a14.91,14.91,0,0,0,11.39-4.88,14.75,14.75,0,0,0,3.43-11.75l-9-72.93c-1.17-9.57-10-17.35-19.73-17.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-nhat-bang",
    d: "M1774.3,1380a1.88,1.88,0,0,1-.62-.51l-8.29-67.47h58.83a1.82,1.82,0,0,1,.62.52l8.29,67.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1866.79,1693.56h-64.15c-11.19,0-21.36-9-22.72-20l-9-72.93c-1.36-11,6.61-20,17.8-20h64.15c11.18,0,21.35,8.95,22.71,20l9,72.93C1885.94,1684.61,1878,1693.56,1866.79,1693.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1866.79,1696.56h-64.15c-12.64,0-24.16-10.15-25.69-22.62l-9-72.94a20.41,20.41,0,0,1,20.78-23.35h64.15c12.63,0,24.15,10.15,25.69,22.62l9,72.93a20.42,20.42,0,0,1-20.77,23.36Zm-78-112.91a14.9,14.9,0,0,0-11.39,4.88,14.71,14.71,0,0,0-3.43,11.74l9,72.93c1.18,9.57,10,17.36,19.74,17.36h64.15a14.91,14.91,0,0,0,11.39-4.88,14.74,14.74,0,0,0,3.43-11.74l-9-72.94c-1.17-9.57-10-17.35-19.73-17.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1902.8,1987.66h-64.15c-11.19,0-21.36-9-22.71-20l-9-72.93c-1.36-11,6.61-20,17.8-20h64.15c11.19,0,21.36,9,22.71,20l9,72.93C1922,1978.71,1914,1987.66,1902.8,1987.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1902.8,1990.66h-64.15c-12.63,0-24.16-10.15-25.69-22.62l-9-72.93a20.42,20.42,0,0,1,20.78-23.36h64.15c12.63,0,24.16,10.15,25.69,22.62l9,72.94a20.59,20.59,0,0,1-4.89,16.44A20.81,20.81,0,0,1,1902.8,1990.66Zm-78-112.91a14.9,14.9,0,0,0-11.39,4.88,14.71,14.71,0,0,0-3.43,11.74l9,72.94c1.18,9.57,10,17.35,19.74,17.35h64.15a14.9,14.9,0,0,0,11.39-4.88,14.71,14.71,0,0,0,3.43-11.74l-9-72.93c-1.17-9.57-10-17.36-19.73-17.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-nhat-bang",
    d: "M1838.82,1965.19a1.65,1.65,0,0,1-.61-.51l-8.3-67.46h58.83a1.7,1.7,0,0,1,.62.51l8.3,67.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "da-dam",
    d: "M2851.25,1678.32l-12.9,21.53c-20.51,11.69-43.27,23.55-67.19,34.18-12.16-16.51-26.5-44.91-33.77-63.46-8.94-22.9-46.22-84.18-55.92-100l25.15-17.14,11.49,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3129.5,1528.81s-50.67,33.34-186.25,130q-31.87,22.74-70.17,50.24l-16.8,12.08c-80.64,27.87-168.42-174.37-168.42-174.37l84.43-57.52h0l111.18-75.73,141.84-96.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vang-dam",
    d: "M2684.76,1548.34s49.09,119.75,85.67,154,72.51,36,82.6,31.8l10.08-4.24s-84.22-91.68-108.6-132.12-26.35-64-38.64-64.42S2680,1543.92,2684.76,1548.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2955.79,1635.75q-29.73,21.21-65.45,46.86c1.54-16.37,3.19-33.71,3.55-37.28.74-7.12,9.39-146.22,2.46-143.35s-98.76-24-100-24.37L2900,1407l19.44,4c82.87,17.17,61,37.36,61,37.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2920.37,1433.06s50.69,394.89,71.43,424.63,170.33,0,170.33,0l-191.94-443.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4056.22,3213.92a144.3,144.3,0,0,0-162.45-111.76c-17.16-71.37-58.45-130.87-115.09-162.44-78.75-43.9-184.15-32.15-272.13,21.4-28.91-75.63-96.39-129.09-174.28-137.59-89.88-9.81-178.47,41.92-217.09,128.42-22.43-27.08-159.34-125.71-336.26-118.14-112.6,4.83-174.63,52.38-245.9,133.81,0,0-309.49-177.93-492.55,65.15S2225.41,3377,2225.41,3377L3819.77,3353a144.3,144.3,0,0,0,236.45-139.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2115.41,2951.58s-50.92,81.66-159.94,59.76C1971.78,2912.51,2055.13,2889.31,2115.41,2951.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2230.48,3008.91a3,3,0,0,1-2.06-.81c-.24-.23-25.05-23.35-64.4-39.9-36.16-15.21-92.41-27.84-155.06-1.64a3,3,0,0,1-2.31-5.54,197.34,197.34,0,0,1,88.13-15.4,216.72,216.72,0,0,1,71.76,17.13c40.3,17,65,40,66,41a3,3,0,0,1,.12,4.24A3,3,0,0,1,2230.48,3008.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2116.52,2853s-8.73-59.79-46.78-96.71c-24.06-23.34-63.41-47.94-111.52-48.46C1936.79,2784.69,2017.45,2871.45,2116.52,2853Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2183.23,2833.81s160.35-95.14,101.83-228.68C2181.13,2624.82,2143.84,2729.89,2183.23,2833.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2320.12,2976.18s182.51-46.44,124-180C2340.19,2815.89,2280.73,2872.26,2320.12,2976.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2597.72,2695.12s174.23-54.71,115.71-188.26C2609.51,2526.56,2558.32,2591.2,2597.72,2695.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2530.68,2734s24.14-130.83-82.63-149.24C2417.35,2657.45,2450.13,2715.82,2530.68,2734Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2778.92,2737.49s-125-49.53-174.63,46.76C2664.42,2835.4,2737.39,2808.86,2778.92,2737.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2394.14,3316.35a3,3,0,0,1-2.79-1.88c-.34-.84-34.65-85.52-92.72-190.11-53.55-96.43-138.81-230-240.93-318.66l-85.19-72.24a3,3,0,0,1,3.88-4.58l85.21,72.27C2107.05,2840.6,2152.94,2892,2198,2954c36,49.54,71.66,105.9,105.87,167.52,58.24,104.9,92.67,189.86,93,190.71a3,3,0,0,1-2.78,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2205,2970.62a3,3,0,0,1-2.77-1.85c-.18-.43-18.1-44.14-21-102.53-1.67-34.34,2.09-67,11.2-97.09a245.55,245.55,0,0,1,58.94-100.08,3,3,0,1,1,4.32,4.16c-61.21,63.51-71,139.74-68.47,192.51,2.77,57.4,20.33,100.31,20.51,100.73a3,3,0,0,1-1.62,3.92A3,3,0,0,1,2205,2970.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2307,3136.34a3,3,0,0,1-3-2.59c-.07-.49-6.47-49.21,2.73-107.78,5.41-34.46,15.08-65.58,28.74-92.49,17.13-33.74,40.61-60.91,69.78-80.76a3,3,0,1,1,3.38,5c-64.18,43.67-87.6,116-95.95,169.06-9.09,57.73-2.8,105.72-2.74,106.2a3,3,0,0,1-2.57,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2525.14,3287.7a3,3,0,0,1-2.87-2.12c-20.65-67.16-26.71-146.3-18-235.22,6.95-71,23.27-148.43,48.52-230.06,43-138.92,97.68-243.41,98.23-244.45a3,3,0,0,1,5.31,2.8c-.54,1-55,105.11-97.84,243.53-39.44,127.54-76.74,311.16-30.46,461.64a3,3,0,0,1-2,3.74A2.7,2.7,0,0,1,2525.14,3287.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2553.65,2830.66a2.94,2.94,0,0,1-1.74-.55,3,3,0,0,1-.71-4.18c23.74-33.38,64.73-51.86,94.94-61.48a320,320,0,0,1,60.29-13,3,3,0,0,1,.55,6c-1.07.09-107.2,10.54-150.89,72A3,3,0,0,1,2553.65,2830.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2553.65,2822.39a3,3,0,0,1-3-3c0-70.2-63.91-145.53-64.55-146.29a3,3,0,1,1,4.55-3.9,354.32,354.32,0,0,1,32.95,47.5c15.08,25.9,33.05,64.74,33.05,102.69A3,3,0,0,1,2553.65,2822.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3858.54,2544.16s39.83-182-140.07-161.8C3718.56,2514.36,3858.54,2544.16,3858.54,2544.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3913.84,2576.89s259.27,17.8,239.23-197.39C3977.34,2387.84,3915.88,2505,3913.84,2576.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3839,2789.45s109.17,197.32,329.2,74.9C4118,2743.07,4014.92,2629.2,3839,2789.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3614.61,3444h-.28a3,3,0,0,1-2.71-3.26c.18-2,20.26-204.78,89.82-432,40.2-131.31,88.88-244.88,144.69-337.55,69.76-115.85,151-199.29,241.39-248a3,3,0,1,1,2.85,5.28c-202.91,109.29-320.38,376.82-383.19,582-69.39,226.68-89.4,428.85-89.59,430.83A3,3,0,0,1,3614.61,3444Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3770.7,2833.73a3,3,0,0,1-2.08-5.16c1.12-1.08,28-26.57,76.36-42.29a244.82,244.82,0,0,1,88.75-11.5c38.09,2,77.3,12.54,116.55,31.35a3,3,0,0,1-2.6,5.41c-87-41.72-157.1-33.71-200.56-19.64-47.14,15.26-74.07,40.74-74.34,41A3,3,0,0,1,3770.7,2833.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3857.28,2660.62a3.22,3.22,0,0,1-.81-.11,3,3,0,0,1-2.08-3.7c.08-.3,8.46-30.82,6.45-70.38-1.84-36.31-13.07-87.94-56.1-127.72a3,3,0,0,1,4.08-4.41c44.57,41.21,56.15,94.54,58,132,2,40.5-6.32,70.84-6.67,72.11A3,3,0,0,1,3857.28,2660.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 3597.7,
    cy: 2740.62,
    r: 91.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "nen-xanh",
    cx: 2960.68,
    cy: 3429.79,
    rx: 1084.01,
    ry: 181.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "vang-decor",
    points: "3668.59 3220.43 3555.76 3265.82 3535.93 3194.56 3648.75 3149.17 3668.59 3220.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "vang-decor",
    points: "3153.45 3291.24 3037.2 3320.13 3023.89 3250.49 3140.14 3221.6 3153.45 3291.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3094.21,1878.5s-295.23,523-245.05,792.9c51.86,279,153.59,588.26,153.59,588.26,54.56.34,107.23-10.58,158.49-29.88,3.1-266.06-4.76-473.9-50.42-624.38,0,0,124.42-174.15,184.46-337.54,29.26-79.63,22.47-180.36,18.53-211.56-12-95.2-32.79-172.17-32.79-172.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3239.74,2257.21s-83.92,175.52-131.77,228.05-52.55,128.91-52.55,128.91,60.49,188.83,67.4,261.82c5.4,57.07,10.2,263.74,13.19,362.54q12.67-4.05,25.23-8.75c3.1-266.06-4.76-473.9-50.42-624.38,0,0,124.42-174.15,184.46-337.54l-7.06-20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3198.91,2362.26S3181,2212.81,3216.84,2153s43.34,170.37,43.34,170.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3209.38,2223.33c15.53,177-7.12,308.1,34.38,449.86,61.51,210.08,276.07,534.64,276.07,534.64,53,.15,101.73-14.86,145.43-47.92l-171.19-610.26s121.48-433.56,80.56-572.71-107.86-198.18-107.86-198.18l-254.39,99.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3574.63,1976.94c-40.91-139.16-107.86-198.18-107.86-198.18l3.65,121.39s52.85,308.62,30.43,420.2-67.67,237.53-67.67,237.53,176.73,452.69,217.24,612.42q7.51-4.86,14.84-10.39l-171.19-610.26S3615.55,2116.09,3574.63,1976.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3203.63,1186.79l-172.12,46.41-22.47-88s-80.23,6.31-91-66.37c-25.65-170.85-1.4-256.56,145.91-254.75,73.66.89,105.2,90,103.91,194.21S3203.63,1186.79,3203.63,1186.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2998.65,1194l19,17.93,208.48-34.75-35.92-63.94S3049.08,1144.63,2998.65,1194Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2931.2,1390.3s117.54,477.76,139.38,493.83c164.3,119.29,446.12-28.66,446.12-28.66s-116.82-598.18-298.37-686.86S2927.62,1339.22,2931.2,1390.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3010.47,1466.45l7.58,49s21.47,277,137,369.11,388.37-19.2,388.37-19.2-115.19-439.85-169.3-529.52c0,0-100.17-178.92-188.38-180.22,0,0-60.48-35.07-165.63,38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3058.62,965.19c24.07-22.83,50.31,15.21,49.61,49.59s44.1,58,44.1,58c18.77,3.26,19.27,5.07,35.57-10.37,0,0,15.86-170.57-34.64-218.08-11-10.36-60.35-53.13-126.18-48.14-46,3.47-131.6,58-184.87,50.72,12.54,84.62,101.33,74.31,101.33,74.31a89.32,89.32,0,0,0,32.67,19c42.42,13.69,43.43,47.43,43,50.44,0,0,10.59,46.35,15.7,47.28s14.39-6,14.39-6S3034.55,988,3058.62,965.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3389.24,3523.2c12.33,27.7,84.25-5.68,104-16.11s172.82-108.68,239.23-162.85c.38-5.37-3.1-16.16-8.68-29.6-18.77-45.25-61.41-120.56-61.41-120.56s-17.72,13.4-38.52,31.76-75,33.28-75,33.28-58,90.27-80.4,132.07c-20,37.33-77.28,91.14-80.54,122A19.3,19.3,0,0,0,3389.24,3523.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3389.24,3523.2c12.33,27.7,84.25-5.68,104-16.11s172.82-108.68,239.23-162.85c.38-5.37-3.1-16.16-8.68-29.6-48.16,34.36-201.4,143.27-240.95,166.33-31.33,18.26-71.48,27.82-94.87,32.19A19.3,19.3,0,0,0,3389.24,3523.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M3530.77,3315.48l3-6.13c2.35-4.77,1-10.94-2.93-13.78l-5.09-3.63c-4-2.84-9.1-1.26-11.46,3.51l-3,6.12c-2.36,4.78-1.05,10.95,2.92,13.78l5.09,3.64C3523.28,3321.82,3528.41,3320.25,3530.77,3315.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M3505.67,3355l3-6.13c2.36-4.77,1-10.94-2.92-13.78l-5.09-3.63c-4-2.84-9.11-1.27-11.46,3.51l-3,6.12c-2.36,4.78-1.05,10.95,2.92,13.78l5.1,3.64C3498.18,3361.34,3503.31,3359.77,3505.67,3355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M3486.2,3391.19l3-6.12c2.36-4.78,1.05-11-2.92-13.78l-5.09-3.64c-4-2.83-9.1-1.26-11.46,3.51l-3,6.13c-2.36,4.77-1.05,10.94,2.92,13.78l5.09,3.63C3478.71,3397.54,3483.84,3396,3486.2,3391.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2804.29,3449.37c2.28,29.69,79.32,32.8,100.86,32.54s194.43-17.35,273.21-34.85c2.1-4.51,2.43-15.48,1.69-29.7-2.48-47.88-17.07-132.66-17.07-132.66s-20.67,3.74-45.8,10.43-79.81-4.56-79.81-4.56-82.79,52.77-117.09,79.17c-30.62,23.58-100.85,44.86-113.92,70.28A17.29,17.29,0,0,0,2804.29,3449.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2804.29,3449.37c2.28,29.69,79.32,32.8,100.86,32.54s194.43-17.35,273.21-34.85c2.1-4.51,2.43-15.48,1.69-29.7-55.52,8.39-232,34.71-275.93,37.1-34.78,1.89-74.82-7.76-97.76-14.44A17.29,17.29,0,0,0,2804.29,3449.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M3002.32,3331.62l4.78-4a10.43,10.43,0,0,0,1.82-13.32l-3.5-5.46c-2.72-4.25-8-5.18-11.68-2.07l-4.79,4a10.42,10.42,0,0,0-1.81,13.32l3.49,5.46C2993.36,3333.8,2998.59,3334.73,3002.32,3331.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M2966.32,3354.84l4.78-4a10.44,10.44,0,0,0,1.82-13.33l-3.5-5.45c-2.73-4.25-8-5.18-11.69-2.07l-4.78,4a10.43,10.43,0,0,0-1.81,13.33l3.49,5.45C2957.36,3357,2962.59,3357.94,2966.32,3354.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M2936.59,3377.68l4.78-4a10.44,10.44,0,0,0,1.82-13.33l-3.5-5.45c-2.72-4.26-8-5.18-11.68-2.08l-4.79,4a10.43,10.43,0,0,0-1.81,13.33l3.49,5.45C2927.63,3379.86,2932.86,3380.79,2936.59,3377.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "da-dam",
    d: "M3016,1172.4l-6.74-26.43c6.93-2.27,30.18-8.25,60.23-28.45C3061.7,1151.36,3032.94,1166.37,3016,1172.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2240,1204.39s225.39,294.34,406.64,333.87c141.05,30.76,398.39-112.54,398.39-112.54l-45-168.81s-326.36,111.79-358.62,106.54c-12.21-2-332.37-201.07-332.37-201.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3120.32,1477.18a116.72,116.72,0,0,1-12.79,6.5c-33.13,15-134.35,50.62-346.87,50-4.19-1.52-10.87-10.08-18.89-22.82-32.79-52.14-60.3-170-60.3-170s215.54-62,344.85-152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M3107.53,1483.68c-33.13,15-134.35,50.62-346.87,50-4.19-1.52-10.87-10.08-18.89-22.82l7.52-19.42s120.22,4.22,226.05,3.82C3041.66,1495,3084.67,1488.49,3107.53,1483.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 4129.7,
    cy: 3078.48,
    r: 71.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "vang-decor",
    d: "M2639.06,1338s82.54,205.13,99,213.22,65.59-7.85,65.59-7.85-101.19-222.75-124.87-223.65S2639.06,1338,2639.06,1338Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2222.53,1148.87c-16-10-23-42.51-23.5-53s-10.76-58-10.76-58c-5.47-14.28,26-1.9,31.51,12.38,0,0,7.25,18.13,28.26,42.14,0,0,11.88,19.38,31.76,24.26s40.89,50.64,40.89,52.89-1.5,4.51-9.75,3.76S2222.53,1148.87,2222.53,1148.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "tim-nhat-bang",
    x: 1532.17,
    y: 1147.52,
    width: 28.57,
    height: 131.26,
    rx: 14.28,
    transform: "translate(-115.08 163.12) rotate(-5.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "tim-nhat-bang",
    x: 1547.61,
    y: 1298.86,
    width: 28.57,
    height: 131.26,
    rx: 14.28,
    transform: "translate(-130.35 165.47) rotate(-5.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-bang",
    d: "M1583.53,1554.79h0a13.91,13.91,0,0,1-15.26-12.43l-5-50a13.92,13.92,0,0,1,12.44-15.25h0a13.91,13.91,0,0,1,15.25,12.43l5,50A13.92,13.92,0,0,1,1583.53,1554.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1772.63 1001.82 1835.65 1061.84 1934.68 954.55 1909.17 932.8 1836.4 1012.33 1804.89 978.56 1772.63 1001.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "nen-xanh",
    x: 1951.19,
    y: 990.57,
    width: 111.79,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2099.37,
    y: 990.57,
    width: 163.04,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "nen-xanh",
    x: 1951.19,
    y: 1048.34,
    width: 204.07,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1891.54,
    y: 1312.43,
    width: 288.47,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vang-decor",
    x: 1891.54,
    y: 1370.2,
    width: 204.07,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1916.3,
    y: 1608.41,
    width: 152.93,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vang-decor",
    x: 2096.86,
    y: 1608.41,
    width: 152.93,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1916.3,
    y: 1666.18,
    width: 280.22,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1956.82,
    y: 1899.88,
    width: 111.79,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vang-decor",
    x: 2090.74,
    y: 1899.88,
    width: 77.78,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2194.27,
    y: 1899.88,
    width: 126.54,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1956.82,
    y: 1957.65,
    width: 147.93,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vang-decor",
    x: 2125.87,
    y: 1957.65,
    width: 77.4,
    height: 22.51,
    rx: 11.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_35",
    "data-name": "Artwork 35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tim-bang",
    d: "M1814.71,2360.35a172,172,0,0,0-129.06,119.06l159,50.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "da-dam",
    d: "M1918.45,2370.38,1844.66,2530l139.87-109.56a172.61,172.61,0,0,0-66.08-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1720.94,2641.94a172.09,172.09,0,0,0,28.75,26.22c76.92,55.66,184.78,38.37,240.44-38.54a171.63,171.63,0,0,0,30.4-128.48L1844.66,2530Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vang-decor",
    d: "M1918.45,2370.38a172.34,172.34,0,0,0-103.74-10l30,169.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-nhat-bang",
    d: "M1685.65,2479.41a172.84,172.84,0,0,0,35.29,162.53l123.72-112Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-nhat-bang",
    d: "M2020.53,2501.14a172.28,172.28,0,0,0-36-80.75L1844.66,2530Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2014.49,766.52h-144a25.78,25.78,0,0,1-25.55-22.3l-4.23-31.17h196l3.28,24.23A25.77,25.77,0,0,1,2014.49,766.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2061.1 2110.94 2068.53 2166.56 2117.22 2140.11 2061.1 2110.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1880.97,
    cy: 2141.3,
    rx: 26.51,
    ry: 30.25,
    transform: "translate(-967.85 2227.6) rotate(-50.44)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2327.23 2161.73 2267.69 2161.73 2262.82 2114.38 2322.36 2114.38 2327.23 2161.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "2416.74 1857.69 1607.19 1210.07 1585.77 1006.94 2395.42 1655.58 2416.74 1857.69"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "tim-nhat-bang",
    cx: 4029.16,
    cy: 1220.41,
    r: 286.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 4029.16,
    cy: 1220.41,
    r: 227.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "tim-nhat-bang",
    cx: 4029.16,
    cy: 1220.41,
    r: 160.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 4029.16,
    cy: 1220.41,
    r: 95.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 4029.16,
    cy: 1220.41,
    r: 44.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M4476.89,1336.57l-432.6-120.79c-10.65-5.3-19.26,12-8.61,17.27l438,122.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "do-dam-ao",
    points: "4431.81 1328.18 4465.62 1298.53 4581.45 1315.89 4525.35 1350.13 4431.81 1328.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "do-dam-ao",
    points: "4428.4 1337.25 4445.48 1378.85 4556.95 1414.83 4521.94 1359.21 4428.4 1337.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1655.22,
    cy: 802.04,
    r: 17.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1743.66,
    cy: 800.65,
    r: 17.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "vang-decor",
    cx: 1817.48,
    cy: 802.73,
    r: 17.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-nhat-bang",
    d: "M3639.59,611.05H3303.25a60.31,60.31,0,0,0-60.32,60.32v126a60.31,60.31,0,0,0,59.41,60.3c-5.35,37.06-18.23,95.88-47.32,113.66,92.43-14.7,139.22-93.27,149.91-113.64h234.66a60.31,60.31,0,0,0,60.31-60.32v-126A60.31,60.31,0,0,0,3639.59,611.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3327.86,
    y: 665.15,
    width: 227.15,
    height: 22.4,
    rx: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vang-decor",
    x: 3327.86,
    y: 720.6,
    width: 133.57,
    height: 22.4,
    rx: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3327.86,
    y: 772.86,
    width: 216.75,
    height: 22.4,
    rx: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3491.02,
    y: 720.6,
    width: 133.57,
    height: 22.4,
    rx: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2924.38,974.39s-30.29,47-31.33,63.72,48,18.8,48,18.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_36",
    "data-name": "Artwork 36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2681.47,1929.41a113.68,113.68,0,0,1,76.41,29.43l19.67-20.3A142.51,142.51,0,0,0,2635,1909l8.85,26.81A113.53,113.53,0,0,1,2681.47,1929.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tim-bang",
    d: "M2681.47,2157.65a114.13,114.13,0,0,1-111.21-139.74l-27.61-5.85A142.33,142.33,0,0,0,2782.31,2144l-20-19.91A113.76,113.76,0,0,1,2681.47,2157.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2795.59,2043.53a113.63,113.63,0,0,1-4,29.81l27.13,7.8a143.16,143.16,0,0,0,1.74-68.13l-27.69,5.42A114.12,114.12,0,0,1,2795.59,2043.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2792.81,2018.43l27.69-5.42a142.2,142.2,0,0,0-42.95-74.47l-19.67,20.3A114.22,114.22,0,0,1,2792.81,2018.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "do-dam-ao",
    d: "M2643.81,1935.81,2635,1909a142.6,142.6,0,0,0-92.31,103.06l27.61,5.85A114.53,114.53,0,0,1,2643.81,1935.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vang-decor",
    d: "M2791.63,2073.34a114.13,114.13,0,0,1-29.36,50.71l20,19.91a142.13,142.13,0,0,0,36.45-62.82Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.eb259ca2a77c2eb8547569a094614ea7.svg";
export { ForwardRef as ReactComponent };